import 'react-circular-progressbar/dist/styles.css'

import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'

import { useDirectiveContext } from '../../DirectiveContext'
import { PaceMetric } from '../../Grid/Intramonth/PaceMetric'
import { DirectiveLoadedGrid } from './DirectiveLoadedGrid'
import { MonthlyVolumeChart } from './MonthlyVolumeChart'
import { PricePerformance } from './PricePerformance'

export function DirectiveMetrics({ selectedDirective, directiveMetrics, metricsLoading }) {
  return (
    <>
      <VolumeChart metricsLoading={metricsLoading} directiveMetrics={directiveMetrics} />
      <Vertical flex={3} className='mx-3' background='bg-1' borderRadius={3} border='all'>
        {directiveMetrics && (
          <>
            <SelectedDirectiveDetails
              metricsLoading={metricsLoading}
              selectedDirective={selectedDirective}
              directiveMetrics={directiveMetrics}
            />
            <DirectiveLoadedGrid metricsLoading={metricsLoading} directiveMetrics={directiveMetrics} />
          </>
        )}
      </Vertical>
    </>
  )
}
export function VolumeChart({ directiveMetrics, metricsLoading }) {
  const [chartData, setChartData] = useState([])
  const { selectedDate } = useDirectiveContext()
  useEffect(() => {
    if (!directiveMetrics) {
      return
    }
    const chartMetrics = [...directiveMetrics.volumes]
    const isCurrentMonth = moment(selectedDate)?.isSame(new Date(), 'month')
    chartMetrics.forEach((metric) => {
      metric.date = `${metric.month}/${metric.day}`
      if (!isCurrentMonth || (isCurrentMonth && metric.day > moment().date())) {
        metric.directive_min =
          metric.loaded === 0 && metric.scheduled === 0 ? metric.min : metric.min - metric.loaded - metric.scheduled
      }
    })
    setChartData({ volumes: chartMetrics, rateableVolume: directiveMetrics.rateable_volume })
  }, [directiveMetrics])
  return <MonthlyVolumeChart metricsLoading={metricsLoading} chartData={chartData} />
}
function SelectedDirectiveDetails({ selectedDirective, directiveMetrics, metricsLoading }) {
  return (
    <Horizontal className='directive-stats' background='bg-2' border='bottom'>
      <Vertical verticalCenter flex={1} className='py-3 pl-4'>
        <Texto weight='bold' appearance='medium'>
          DIRECTIVE
        </Texto>
        <Texto category='h4' weight='bold' appearance='secondary'>
          {selectedDirective.name}
        </Texto>
        <Tooltip title='Contract Pace (Minimum)'>
          <div className='pt-2'>
            <PaceMetric
              value={selectedDirective.contract_pace || 0}
              loaded={selectedDirective.loaded}
              allocation={selectedDirective.active_contract_volume}
              letter='C'
              isContract
            />
          </div>
        </Tooltip>
      </Vertical>
      <PricePerformance metricsLoading={metricsLoading} directiveMetrics={directiveMetrics} />
    </Horizontal>
  )
}
